import httpClient from '../httpClient';

const createUnitForm = async (data) => {
  return await httpClient.post(`unit_form/`, data);
};

const createUnitFormMassive = async (data) => {
  return await httpClient.post(`unit_form/massive/`, data);
};

const getUnitForm = async (id) => {
  return await httpClient.get(`unit_form/${id}/`);
};

const updateUnitForm = async (id, data) => {
  return await httpClient.put(`unit_form/${id}/`, data);
};

const deleteUnitForm = async (id) => {
  return await httpClient.delete(`unit_form/${id}/`);
};

const queryUnitForm = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/unit_form/?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const queryUnitFormUnits = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/unit_form/units?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const queryUnitFormForms = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/unit_form/forms?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

export {
  getUnitForm,
  createUnitForm,
  createUnitFormMassive,
  updateUnitForm,
  deleteUnitForm,
  queryUnitForm,
  queryUnitFormUnits,
  queryUnitFormForms,
}
